<template>
  <authorization permissionKey="configuration_surgery" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text"> Cirurgia </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs background-color="transparent" color="secondary">
            <v-tab to="/configuracoes/cirurgia/materiais">Materiais</v-tab>
            <v-tab to="/configuracoes/cirurgia/cirurgias">Cirurgias</v-tab>
            <v-tab to="/configuracoes/cirurgia/descricao-cirurgica"
              >Descrição cirúrgica</v-tab
            >
            <v-tab to="/configuracoes/cirurgia/descricao-anestesica">
              Descrição anestésica
            </v-tab>
            <v-tab to="/configuracoes/cirurgia/servicos-cirurgicos">
              Serviços Cirúrgicos</v-tab
            >
          </v-tabs>
        </v-col>
      </v-row>

      <router-view />
    </v-container>
  </authorization>
</template>

<script>
export default {
  name: "SurgeryConfig",
};
</script>

<style lang="scss" scoped></style>
